import { sendMetrics } from "./sendMetrics";

/**
 * True for user- or client-initiated aborts (spellcheck superseded, navigation, etc.).
 * Only matches strict AbortError types to avoid misclassifying real failures as benign.
 */
export function isAbortLikeError(error: unknown): boolean {
    // Standard AbortError from AbortController
    if (error instanceof DOMException && error.name === "AbortError") return true;
    if (error instanceof Error && error.name === "AbortError") return true;

    // Handle non-standard error objects with AbortError name
    if (error !== null && typeof error === "object" && "name" in error) {
        const name = (error as { name: unknown }).name;
        if (name === "AbortError") return true;
    }

    // Do NOT match by message text - too broad and could misclassify real failures like:
    // - "Database transaction aborted due to constraint violation"
    // - "Upload aborted: server error"
    // Only strict type matching ensures we identify intentional cancellations.

    return false;
}

export async function sendErrorMetric(errorType: string, additionalDimensions?: Record<string, string>) {
    return await sendMetrics([
        {
            metrics: [{ name: "Error", value: 1 }],
            dimensions: { errorType, surface: "frontend", ...additionalDimensions },
        },
    ]);
}

export async function sendEventMetric(eventName: string, additionalDimensions?: Record<string, string>) {
    return await sendMetrics([
        {
            metrics: [{ name: "Event", value: 1 }],
            dimensions: { eventName, ...additionalDimensions },
        },
    ]);
}
